import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import {
  DEBOUNCED_UPDATE_CONNECT_DEFAULT_REQUEST,
  UPDATE_CONNECT_DEFAULT_SUCCESS,
  UPDATE_CONNECT_DEFAULT_FAILURE,
} from 'Constants/redux';
import service from 'Api/service';
import { ROOT_URL } from 'Api';

const connectDefaultEpic = (action$) =>
  action$.pipe(
    ofType(DEBOUNCED_UPDATE_CONNECT_DEFAULT_REQUEST),
    debounceTime(500),
    switchMap((action) =>
      from(service.patch(`${ROOT_URL}/connect_default/`, action.data)).pipe(
        map((response) => ({
          type: UPDATE_CONNECT_DEFAULT_SUCCESS,
          response: response.data,
        })),
        catchError((error) => {
          console.error('connectDefaultEpic error', error);
          return of({
            type: UPDATE_CONNECT_DEFAULT_FAILURE,
            error,
          });
        })
      )
    )
  );

export default connectDefaultEpic;
